import React from "react";
import styled from "styled-components";
import userImg from "../static/images/user.png";

const LabelName = styled.p`
  text-align: center;
  font: normal normal 600 16px/25px Poppins;
  letter-spacing: 0px;
  color: #646464;
  font-size: 16px;
  opacity: 1;
`;
const LabelCargo = styled.p`
  text-align: center;
  font: normal normal normal 16px/18px Poppins;
  letter-spacing: 0px;
  color: #888888;
  opacity: 1;
`;
const Line = styled.hr`
  margin: 1rem;
  border: 0;
  border: 1px solid #d5d5d5;
  opacity: 1;
`;
const LabelDescripcion = styled.p`
  text-align: left;
  font: normal normal medium 12px/18px Poppins;
  letter-spacing: 0px;
  color: #373737;
  opacity: 1;
  margin-left: 2rem;
  margin-top: 10px;
  margin-bottom: 0px;
`;
const LabelDescripcionPuntuacion = styled.p`
  text-align: right;
  font: normal normal medium 12px/18px Poppins;
  letter-spacing: 0px;
  color: #9100ff;
  opacity: 1;
  margin-right: 2rem;
  margin-top: 10px;
  margin-bottom: 0px;
`;
const btn = {
  background:
    "transparent linear-gradient(196deg, #9100FF 0%, #4B00FF 100%) 0% 0% no-repeat padding-box",
  boxShadow: "0px 10px 20px #6A00FF73",
  borderRadius: "27px",
  opacity: "1",
  color: "#FFFFFF",
  padding: "8px",
  width: "90%",
  borderWidth: "thin",
  maxWidth: "17.0625rem",
};

const infoPerfil = ({ usuario }) => {
  //const { Nombre, Cargo, Contactos, Grupos, Insignias } = usuario;
  const { Nombre, Cargo, Grupos, Insignias } = usuario;
  return (
    <div className="row ml-5">
      <div className="col-md-12">
        <div className="boxWhiteLarge">
          <div className="text-center mt-4">
            <img src={userImg} alt="Perfil"></img>
            <LabelName>{Nombre}</LabelName>
            <LabelCargo className="ml-5 mr-5">{Cargo}</LabelCargo>
            <Line />
            <div className="row">
              <div className="col-md-7">
                {/*<LabelDescripcion>Ver Contactos:</LabelDescripcion>*/}
                <LabelDescripcion>Grupos:</LabelDescripcion>
                <LabelDescripcion>Insignias:</LabelDescripcion>
              </div>
              <div className="col-md-5">
                {/*<LabelDescripcionPuntuacion>
                  {Contactos}
                </LabelDescripcionPuntuacion>*/}
                <LabelDescripcionPuntuacion>
                  {Grupos}
                </LabelDescripcionPuntuacion>
                <LabelDescripcionPuntuacion>
                  {Insignias}
                </LabelDescripcionPuntuacion>
              </div>
            </div>
            <Line />
            <button className="mt-2 mb-4" style={btn}>
              Ver perfil
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default infoPerfil;
